import React, { useEffect, useState } from "react";
import { Table, Col, Tooltip, Pagination, Row, Form, DatePicker, Select, Button, Space } from "antd";
import { EditOutlined, SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { costingExpenseService, dropdownService, invoiceService } from "../../../../../services";
import { changeDocumentTitle } from "../../../../../utils/title";
import dayjs from "dayjs";
import { filter } from "jszip";

function Coasting() {
  const [loading, setLoading] = useState(false);
  const [costing, setCosting] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });

  const [filters, setFilters] = useState({
    dateRange: null,
    customer_id: null,
    invoice_id: null,
  });

  const [customers, setCustomers] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false)
  const [customerLoading, setCustomerLoading] = useState(false)
  const columns = [
    {
      title: "Invoice Number",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Total Invoice Amount",
      dataIndex: "total",
      key: "total",
    },
    {
      title: "Total Transport Charges",
      dataIndex: "total_transportation_charges",
      key: "total_transportation_charges",
    },
    {
      title: "Total Labour Charges",
      dataIndex: "total_labour_charges",
      key: "total_labour_charges",
    },
    {
      title: "Total Material Charges",
      dataIndex: "total_material_charges",
      key: "total_material_charges",
    },
    {
      title: "Total/ Extra Buying Charges",
      dataIndex: "buying_charges",
      key: "buying_charges",
    },
    {
      title: "Total Selling Charges",
      dataIndex: "selling_charges",
      key: "selling_charges",
    },

    {
      title: "Action",
      key: "Action",
      fixed: "right",
      render: (text, record, { _id }) => (
        <Link to={`/accounts/costings/edit/${record.id}`} className="hover:text-primary">
          <Tooltip title='Edit'>
            <EditOutlined />
          </Tooltip>
        </Link>
      ),
    },
  ];

  const initialize = async (
    page = 1,
    pageSize = pagination.pageSize,
    appliedFilters
  ) => {
    const activeFilters = appliedFilters ?? filters;

    setLoading(true);

    const payload = {
      page,
      pageSize,
      customer_id: activeFilters.customer_id ?? null,
      invoice_id: activeFilters.invoice_id ?? null,
      from_date: activeFilters.dateRange?.[0]
        ? dayjs(activeFilters.dateRange[0]).format("YYYY-MM-DD")
        : null,
      to_date: activeFilters.dateRange?.[1]
        ? dayjs(activeFilters.dateRange[1]).format("YYYY-MM-DD")
        : null,
    };

    const { success, data } = await costingExpenseService.fetch(payload);

    if (success) {
      setCosting(data.data);
      setPagination(prev => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }

    setLoading(false);
  };

  const fetchCustomerInvoicesData = async (id) => {
    if (!id) return
    setInvoiceLoading(true)
    const res = await invoiceService.fetchCustomerInvoicesData(id)
    setInvoiceLoading(false)
    if (res.success) setInvoices(res.data);
  }

  const fetchCustomer = async () => {
    setCustomerLoading(true);
    const res = await dropdownService.fetchCustomers()
    setCustomerLoading(false);
    if (res.success) setCustomers(res.data);
  }

  useEffect(() => {
    changeDocumentTitle("Costing Expense");
    initialize(1, pagination.pageSize);
    fetchCustomer()
  }, []);

  const Filters = () => (
    <div className="bg-gray-50 border rounded-lg p-4">
      <Form layout="vertical">
        <Row gutter={16} align="bottom">

          <Col xs={24} sm={12} md={6}>
            <Form.Item label="Date Range" className="m-0 p-0">
              <DatePicker.RangePicker
                className="w-full"
                value={filters.dateRange}
                onChange={(dates) =>
                  setFilters(prev => ({ ...prev, dateRange: dates }))
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item label="Customer" className="m-0 p-0">
              <Select
                allowClear
                showSearch
                placeholder="Select customer"
                optionFilterProp="label"
                loading={customerLoading}
                value={filters.customer_id}
                onChange={(value) => {
                  setFilters(prev => ({ ...prev, customer_id: value }))
                  setInvoices([]);
                  if (value) {
                    fetchCustomerInvoicesData(value);
                  }
                }}

                options={customers.map(c => ({
                  label: c.name,
                  value: c.id,
                }))}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item label="Invoice Number" className="m-0 p-0">
              <Select
                allowClear
                showSearch
                placeholder="Select invoice"
                loading={invoiceLoading}
                optionFilterProp="label"
                value={filters.invoice_id}
                onChange={(value) =>
                  setFilters(prev => ({ ...prev, invoice_id: value }))
                }
                options={invoices.map(inv => ({
                  label: inv.id,
                  value: inv.id,
                }))}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item className="m-0 p-0">
              <Space>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  onClick={() => initialize(1, pagination.pageSize)}
                >
                  Search
                </Button>

                <Button
                  icon={<ReloadOutlined />}
                  onClick={() => {
                    const resetFilters = {
                      dateRange: null,
                      customer_id: null,
                      invoice_id: null,
                    };

                    setFilters(resetFilters);
                    initialize(1, pagination.pageSize, resetFilters);
                  }}
                >
                  Reset
                </Button>
              </Space>
            </Form.Item>
          </Col>

        </Row>
      </Form>
    </div>
  );

  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Col span={24} style={{ padding: 10 }}>
        <h1 style={{ fontWeight: "bold" }}>Costing Expenses</h1>
      </Col>

      {/* Filters */}
      <Filters />

      <Table
        columns={columns}
        scroll={{ x: "max-content" }}
        dataSource={costing}
        rowKey='id'
        loading={loading}
        style={{ marginTop: "10px" }}
        pagination={false}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}
export default Coasting;
